import { _ as _copyObject } from './_copyObject.mjs';
import { _ as _getSymbols } from './_getSymbols.mjs';

var copyObject = _copyObject,
    getSymbols = _getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

var _copySymbols = copySymbols;

export { _copySymbols as _ };
